import { useTranslation } from "react-i18next";
import {
  FaBolt,
  FaSearchDollar,
  FaHandshake,
  FaGlobeAmericas,
} from "react-icons/fa";
import ServicesBgImg from "../assets/services-bg-img.jpg";

function Services() {
  const { t: translate } = useTranslation();

  const services = [
    {
      key: "service1",
      icon: <FaBolt />,
    },
    {
      key: "service2",
      icon: <FaSearchDollar />,
    },
    {
      key: "service3",
      icon: <FaHandshake />,
    },
    {
      key: "service4",
      icon: <FaGlobeAmericas />,
    },
  ];

  return (
    <section
      id="services"
      className="services"
      style={{ backgroundImage: `url(${ServicesBgImg})` }}
    >
      <div className="row">
        <div data-aos="fade-up">
          <h2 className="section__title">{translate("services.title")}</h2>
          <div className="section__divider"></div>
          <h3 className="services__subtitle">
            {translate("services.subtitle")}
          </h3>
          <p className="services__description">
            {translate("services.description")}
          </p>
        </div>
        <div className="services__grid">
          {services.map((service, index) => (
            <div
              className="service-card"
              key={service.key}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <div className="service-card__icon">{service.icon}</div>
              <h4 className="service-card__title">
                {translate(`services.${service.key}.title`)}
              </h4>
              {(() => {
                const description = translate(
                  `services.${service.key}.description`
                );
                const markers = ["What this includes:", "Lo que incluye:"];
                let mainText = description;
                let includesText = null;

                for (const marker of markers) {
                  const idx = description.indexOf(marker);
                  if (idx !== -1) {
                    mainText = description.substring(0, idx).trimEnd();
                    includesText = description.substring(idx);
                    break;
                  }
                }

                return (
                  <>
                    <p className="service-card__description">{mainText}</p>
                    {includesText && (
                      <p className="service-card__includes">{includesText}</p>
                    )}
                  </>
                );
              })()}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
